import useApi from "@action.sustainability/storybook-dashboard/utils/fetching";

export const useCompanyPermission = ({ companyId }) => {
  const { data } = useApi(`/api/company/${companyId}/permission/`);
  return {
    permission: data,
    isAdmin: data?.get("is_admin"),
  };
};
